export default {"src":"/_next/static/media/truck.bca7c3c3.svg","height":214,"width":268,"blurWidth":0,"blurHeight":0};